<script>
import { AppLayout, PageHeader } from '@/components/layout'
import appConfig from '@/app.config'

import WelcomeCard from './shared/welcome-card'
import LatestOrdersCard from './shared/latest-orders-card'
import DashboardMetrics from './shared/dashboard-metrics.vue'
import DashboardActivity from './shared/dashboard-activity.vue'

export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    AppLayout,
    PageHeader,
    WelcomeCard,
    LatestOrdersCard,
    DashboardMetrics,
    DashboardActivity
  },
  data () {
    return {
      title: 'Dashboard',
      items: [
        {
          text: 'Home',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <AppLayout>
    <PageHeader :title="$t('dashboard')" :items="items" />

    <div class="portal-dashboard">
      <welcome-card class="mb-3" />

      <dashboard-metrics />

      <div class="portal-grid portal-grid--main mb-3">
        <div class="portal-span-2">
          <latest-orders-card :length="5" />
        </div>
        <div>
          <dashboard-activity />
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<style lang="scss" scoped>
.portal-dashboard {
  margin-bottom: 1.5rem;
}

.portal-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 992px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.portal-grid--main {
  align-items: stretch;
}

.portal-span-2 {
  @media (min-width: 992px) {
    grid-column: span 2;
  }
}
</style>
